import React, { useContext } from 'react';
import styled from 'styled-components';
import { Body, FlexColumn, Header2SemiBold, Loader } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import RecordsTab from './RecordsTab';

const Section = styled(FlexColumn)`
  gap: 12px;
`;

const SectionTitle = styled(Header2SemiBold)`
  font-size: 16px;
  line-height: 24px;
`;

const SectionSubtitle = styled(Body)`
  color: ${({ theme }) => theme.colors.grey4};
`;

const LeaveHistory = ({ history, isLoading, onCancelRecord }) => {
  const { t } = useContext(ConfigContext);

  if (isLoading) return <Loader />;

  return (
    <Section>
      <SectionTitle>{t('leaveHistory')}</SectionTitle>
      <SectionSubtitle>{t('leaveHistoryRecordsHint')}</SectionSubtitle>
      <RecordsTab records={history?.records || []} onCancelRecord={onCancelRecord} />
    </Section>
  );
};

export default LeaveHistory;
